<h2 mat-dialog-title>
  {{ 'LIST_OBJECTS_TABLE.ACTIONS.DELETE.MODAL_TITLE' | translate : { name: objectType.toLowerCase() } }}
</h2>
<mat-dialog-content>
  <p>{{ 'LIST_OBJECTS_TABLE.ACTIONS.DELETE.CONFIRMATION_MESSAGE' | translateByObjectType : objectType }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close [attr.data-action]="'cancel-delete-crm-' + objectType.toLowerCase()">
    {{ 'LIST_OBJECTS_TABLE.ACTIONS.DELETE.CANCEL' | translateByObjectType : objectType }}
  </button>
  <button
    mat-flat-button
    color="warn"
    mat-dialog-close
    (click)="onConfirmClick()"
    data-testid="confirm-delete-crm-object-button"
    [attr.data-action]="'confirm-delete-crm-' + objectType.toLowerCase()"
  >
    {{ 'LIST_OBJECTS_TABLE.ACTIONS.DELETE.CONFIRM' | translateByObjectType : objectType }}
  </button>
</mat-dialog-actions>
